import { render, staticRenderFns } from "./BackupRequestPage.vue?vue&type=template&id=c3172186&"
import script from "./BackupRequestPage.vue?vue&type=script&lang=js&"
export * from "./BackupRequestPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports